import * as React from 'react';
import styled from '@emotion/styled';
import { MediaIcon, MediaIconWidget } from '../../content/MediaIconWidget';
import { Font } from '../../../fonts';

export interface MetaItem {
  label: string;
}

export interface ListItemWidgetProps {
  meta: MetaItem[];
  label: string;
  media: Omit<MediaIcon, 'name'>;
  action?: () => any;
}

export const ListItemWidget: React.FC<React.PropsWithChildren<ListItemWidgetProps>> = (props) => {
  return (
    <S.Container
      onClick={() => {
        props.action?.();
      }}
    >
      <S.Left>
        <S.Media>
          <S.ListIcon
            media={{
              ...props.media,
              name: props.label
            }}
          />
        </S.Media>
        <S.Label>{props.label}</S.Label>
      </S.Left>
      <S.Right>
        {props.meta.map((m) => {
          return <S.MetaItem key={m.label}>{m.label}</S.MetaItem>;
        })}
      </S.Right>
    </S.Container>
  );
};
namespace S {
  export const ListIcon = styled(MediaIconWidget)`
    width: 40px;
    height: 40px;
  `;

  export const Container = styled.div`
    padding: 10px;
    background: ${(p) => p.theme.button_secondary.background};

    border-radius: 5px;
    display: flex;
    column-gap: 10px;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background: ${(p) => p.theme.button_secondary.background_hover};
    }
  `;

  export const Media = styled.div`
    max-width: 40px;
    max-height: 40px;
    font-size: 25px;
  `;

  export const Label = styled.div`
    font-size: 16px;
    font-family: ${Font.Normal};
    color: white;
  `;

  export const Left = styled.div`
    display: flex;
    align-items: center;
    column-gap: 10px;
  `;

  export const Right = styled.div`
    display: flex;
    align-items: center;
    column-gap: 5px;
  `;

  export const MetaItem = styled.div`
    background: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    font-family: ${Font.Special};
  `;
}
